<div class="min-h-screen bg-[#F9FAFB] flex flex-col font-sans" *ngIf="authService.isLoggedIn(); else authOutlet">

  <app-navbar [currentView]="currentView" [cartQuantity]="getTotalCartQuantity()" [userName]="userName"
    [organisationName]="organisationName" (onViewChange)="handleNavigation($event)" (onCartToggle)="checkout()"
    (logout)="handleLogout()">
  </app-navbar>

  <!-- Main Content Layout -->
  <main [class.pb-24]="getTotalCartQuantity() > 0 && currentView === 'home'"
    class="flex-1 w-full max-w-[1280px] mx-auto px-4 lg:px-8 py-8">

    <!-- Toast Message Stack -->
    <div class="fixed top-16   right-6 z-50 flex flex-col gap-3 max-w-[360px]">
      <div *ngFor="let toast of toasts" [ngClass]="{
          'bg-[#E6F4EA] border-[#B7E1CD] text-[#137333]': toast.type === 'success',
          'bg-[#FCE8E6] border-[#FAD2CF] text-[#C5221F]': toast.type === 'error',
          'bg-[#E8F0FE] border-[#D2E3FC] text-[#1A73E8]': toast.type === 'info'
        }" class="flex items-center justify-between gap-3 p-[12px_16px] rounded-xl border shadow-md animate-slide-in">
        <div class="flex items-center gap-2.5">
          <span class="text-[14px] font-[500]">{{ toast.message }}</span>
        </div>
        <button (click)="removeToast(toast.id)" class="text-current opacity-70 hover:opacity-100 cursor-pointer">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </div>

    <router-outlet></router-outlet>

  </main>


  <!-- Floating Bottom Cart Bar -->
  <div *ngIf="getTotalCartQuantity() > 0 && currentView === 'home'"
    class="fixed bottom-0 left-0 right-0 bg-black text-white py-4 px-6 z-40 shadow-2xl flex items-center justify-between border-t border-neutral-800">
    <div class="max-w-[1280px] mx-auto w-full flex items-center justify-between">
      <div class="text-[15px] font-[600]">
        <span class="text-[#F04438] font-[700] text-[18px] mr-1.5">{{ getTotalCartQuantity() }}</span>
        <span>{{ getTotalCartQuantity() === 1 ? 'Meal' : 'Meals' }} Added</span>
      </div>
      <div class="flex items-center gap-3">
        <button (click)="checkout()"
          class="bg-[#BE2F27] hover:bg-[#A8251E] text-white px-5 py-2.5 rounded-xl text-[14px] font-[700] flex items-center gap-2 transition-all cursor-pointer shadow-sm">
          Checkout
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <circle cx="9" cy="21" r="1"></circle>
            <circle cx="20" cy="21" r="1"></circle>
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
          </svg>
        </button>
        <button (click)="clearCart()"
          class="border border-white/60 hover:border-white text-white hover:bg-white/10 px-5 py-2.5 rounded-xl text-[14px] font-[600] flex items-center gap-2 transition-all cursor-pointer">
          Clear
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Logout Confirmation Modal -->
  <div *ngIf="isLogoutModalVisible"
    class="fixed inset-0 bg-black/40 backdrop-blur-xs flex items-center justify-center z-[9999] p-4">
    <div
      class="bg-white max-w-[400px] w-full rounded-[16px] border border-[#E6E6E6] p-[24px] shadow-[0px_8px_32px_rgba(0,0,0,0.08)] relative">
      <!-- Close Button -->
      <button
        class="absolute top-4 right-4 w-[28px] h-[28px] rounded-full border border-[#E5E5E5] flex items-center justify-center text-[#1A1A1A] hover:bg-gray-50 transition-colors"
        (click)="isLogoutModalVisible = false">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L11 11M1 11L11 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
        </svg>
      </button>

      <!-- Header -->
      <div class="flex flex-col items-center text-center mt-2 mb-6">
        <div class="w-[48px] h-[48px] rounded-full bg-[#FEE4E2] text-[#D92D20] flex items-center justify-center mb-4">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
        </div>
        <h3 class="text-[18px] font-semibold text-[#121212]">Confirm Logout</h3>
        <p class="text-[14px] text-[#6A6A6A] mt-2">Are you sure you want to log out of your account?</p>
      </div>

      <!-- Actions -->
      <div class="flex items-center gap-[12px]">
        <button type="button"
          class="flex-1 py-[12px] rounded-[10px] border border-[#E5E5E5] text-[14px] font-medium text-[#1A1A1A] hover:bg-gray-50 transition-colors cursor-pointer text-center"
          (click)="isLogoutModalVisible = false">
          Cancel
        </button>
        <button type="button"
          class="flex-1 py-[12px] rounded-[10px] bg-[#BE2F27] text-white text-[14px] font-medium hover:bg-[#a12821] transition-colors cursor-pointer text-center"
          (click)="confirmLogout()">
          Logout
        </button>
      </div>
    </div>
  </div>

  <!-- Rate Meal Modal -->
  <app-rate-meal-modal
    *ngIf="showMealRatingModal && currentRatingBooking"
    [booking]="currentRatingBooking"
    (closed)="handleMealRatingClosed()"
    (rated)="handleMealRated($event)">
  </app-rate-meal-modal>

  <!-- Rate Vendor Modal -->
  <app-rate-vendor-modal
    *ngIf="showVendorRatingModal && currentRatingBooking"
    [booking]="currentRatingBooking"
    (closed)="handleVendorRatingClosed()"
    (rated)="handleVendorRated($event)">
  </app-rate-vendor-modal>
</div>

<ng-template #authOutlet>
  <router-outlet (activate)="onRouteActivated($event)"></router-outlet>
</ng-template>